<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启互联支付" >
        <el-switch v-model="form.is_open"></el-switch>
      </el-form-item>

      <el-form-item  label="返佣比例"  label-width="150px">
    
      <el-input v-model="form.rebate" type="number"
          style="width: 160px;"></el-input>%

          <div>
          选择互联支付100元，会返佣{{   getPrice((form.rebate/100 ) * 100 ) }}元给门店/商城
        </div>
      </el-form-item>

    
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import IniApi from '@/api/ini.js';
export default {
  data() {
    return {
      form: {
        is_open:false,
        rebate:0,
      },
      setting: [],
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        return this.roundToDecimalPlace(price,2)
      },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      IniApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
       
        })
        .catch(error => {});
    },

    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      IniApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ini/setting/getSetting.vue